import { render, staticRenderFns } from "./NewsDetail.vue?vue&type=template&id=e159ea62"
import script from "./NewsDetail.vue?vue&type=script&lang=js"
export * from "./NewsDetail.vue?vue&type=script&lang=js"
import style0 from "./NewsDetail.vue?vue&type=style&index=0&id=e159ea62&prod&lang=less"
import style1 from "./NewsDetail.vue?vue&type=style&index=1&id=e159ea62&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports